var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9v3h26V9H7zM6 6h28c1.063 0 2 .938 2 2v5c0 1.125-.938 2-2 2H6c-1.125 0-2-.875-2-2V8c0-1.063.875-2 2-2zm8 13.5c0-.813.625-1.5 1.5-1.5h9c.813 0 1.5.688 1.5 1.5 0 .875-.688 1.5-1.5 1.5h-9c-.875 0-1.5-.625-1.5-1.5zM6 30V17h3v13c0 .563.438 1 1 1h20c.5 0 1-.438 1-1V17h3v13c0 2.25-1.813 4-4 4H10c-2.25 0-4-1.75-4-4z"
  })));
}
export default SvgInventory;